<template>
    <DCard
        :title="__('customers.contracts.connections.title')"
        :padding="true"
    >
        <template #default>
            <div class="detail">
                <div
                    v-for="connection in connections"
                    :key="`${connection.connection_type}-${connection.id}`"
                    class="two-columns"
                >
                    <span>{{ __(`customers.contracts.connections.types.${connection.connection_type}`) }}</span>
                    <span>
                        <Link :href="contractUrl(connection)">
                            #{{ connection.id }}<template v-if="connection.product_name"> - {{ connection.product_name }}</template>
                        </Link>
                    </span>
                    <span />
                </div>
            </div>
        </template>
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'

defineProps({
    connections: {
        type: Array,
        required: true
    }
})

function contractUrl (connection) {
    return route('customers.customers.contracts.show', {
        customer: connection.customer_id,
        contract: connection.id
    })
}
</script>
